// ProBadge
// ========
//
// Wave 14ca-fix26: kleines rotes "PRO"-Schleifchen für Features die später
// kostenpflichtig werden (Create Custom, Custom Trails, Battery Lab, …).
//
// Design-Entscheidung: ein "Ribbon"-Look (Schleife mit Knick), absolut
// positioniert in der oberen rechten Ecke des parent-Containers. Parent
// muss `relative` sein damit die absolute-Positionierung greift.
//
// Optisch: scharf rot (#dc2626 = red-600), weisser Bold-Text, kleiner
// Drop-Shadow für Tiefe. Bewusst NICHT subtil — soll als "Premium-Marker"
// auffallen, ohne den Kachel-Inhalt zu verdecken (ribbon ist top-right,
// Kachel-Text liegt bottom-left).

export interface ProBadgeProps {
  /** 'corner' = absolute top-right ribbon (default, für Tiles/Cards).
      'inline' = inline-pill (für Headers / Listen). */
  variant?: 'corner' | 'inline';
  /** Custom-Text statt 'Pro'. Wave 14ca-fix46: erlaubt z.B. 'Vertical Lodge'
      als zweite Ebene fuer kunden-exklusive Features. */
  label?: string;
  /** Wave 14ca-fix46: Offset von oben fuer gestapelte Badges. 0 (default) =
      die normale top:8px Position; 1 = darunter (top:34px); 2 = noch tiefer.
      Wird genutzt wenn mehrere Badges am gleichen Tile sitzen muessen. */
  stackIndex?: number;
}

export function ProBadge({
  variant = 'corner',
  label = 'Pro',
  stackIndex = 0,
}: ProBadgeProps) {
  if (variant === 'inline') {
    return (
      <span
        className="inline-flex items-center px-2 py-[2px] rounded-md bg-red-600 text-white text-[10px] font-bold tracking-[0.1em] uppercase shadow-sm"
        aria-label={`${label} feature`}
      >
        {label}
      </span>
    );
  }
  // Corner-Variant: ribbon-Style oben rechts. `pointer-events-none` damit
  // der Badge nicht den Tap auf die darunterliegende Kachel klaut.
  // stackIndex steuert vertikales Offset: 0=8px, 1=34px, 2=60px (je 26px
  // pro Stufe = Badge-Hoehe ~22px + 4px gap).
  const top = 8 + stackIndex * 26;
  return (
    <span
      className="absolute right-2 z-10 inline-flex items-center px-2 py-[3px] rounded-md bg-red-600 text-white text-[10px] font-bold tracking-[0.1em] uppercase shadow-md pointer-events-none whitespace-nowrap"
      style={{ top: `${top}px` }}
      aria-label={`${label} — premium tier`}
    >
      {label}
    </span>
  );
}
